import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import { useCart } from '../context/CartContext';
import { WOW } from 'wowjs';

const products = [
  { id: 'p1', img: '/images/resource/pricing2-1.png', title: 'Luxury Towel Set',    price: 39,  oldPrice: 55,  badge: 'Sale',  type: 'product' },
  { id: 'p2', img: '/images/resource/pricing2-2.png', title: 'Scented Candle',      price: 16,  oldPrice: null, badge: 'New',  type: 'product' },
  { id: 'p3', img: '/images/resource/pricing2-3.png', title: 'Premium Bathrobe',    price: 89,  oldPrice: 120, badge: 'Sale',  type: 'product' },
  { id: 'p4', img: '/images/resource/pricing2-4.png', title: 'Pillow Set',          price: 45,  oldPrice: null, badge: null,   type: 'product' },
  { id: 'p5', img: '/images/resource/pricing2-5.png', title: 'Room Diffuser',       price: 28,  oldPrice: null, badge: 'New',  type: 'product' },
  { id: 'p6', img: '/images/resource/pricing2-6.png', title: 'Hotel Slippers',      price: 19,  oldPrice: 28,  badge: 'Sale',  type: 'product' },
  { id: 'p7', img: '/images/resource/pricing2-7.png', title: 'Toiletry Gift Kit',   price: 35,  oldPrice: null, badge: null,   type: 'product' },
  { id: 'p8', img: '/images/resource/pricing2-8.png', title: 'Mineral Water Pack',  price: 12,  oldPrice: null, badge: null,   type: 'product' },
];

function ProductCard({ product }) {
  const { addToCart, cartItems } = useCart();
  const [flash, setFlash] = useState(false);
  const inCart = cartItems.some(i => i.id === product.id && i.type === 'product');

  const handleAdd = () => {
    addToCart({ id: product.id, title: product.title, price: product.price, img: product.img, type: 'product' });
    setFlash(true);
    setTimeout(() => setFlash(false), 1800);
  };

  return (
    <div className="product-card">
      <div className="product-img-wrap">
        <img src={product.img} alt={product.title} />
        {product.badge && <span className={`product-badge ${product.badge.toLowerCase()}`}>{product.badge}</span>}
        {inCart && <span className="product-incart-badge"><i className="fas fa-cart-shopping"></i></span>}
      </div>
      <div className="product-body">
        <h6 className="product-title">{product.title}</h6>
        <div className="product-pricing">
          <span className="product-price">${product.price.toFixed(2)}</span>
          {product.oldPrice && <span className="product-old-price">${product.oldPrice.toFixed(2)}</span>}
        </div>
        <button
          className={`product-add-btn${flash ? ' flash' : ''}${inCart ? ' incart' : ''}`}
          onClick={handleAdd}
        >
          {flash
            ? <><i className="fas fa-check"></i> Added!</>
            : inCart
              ? <><i className="fas fa-cart-shopping"></i> In Cart</>
              : <><i className="fas fa-cart-plus"></i> Add to Cart</>}
        </button>
      </div>
    </div>
  );
}

export default function ShopProducts() {
  const { cartCount } = useCart();

  useEffect(() => {
    new WOW({ mobile: false }).init();
  }, []);

  return (
    <div className="page-wrapper">
      <Preloader />
      <Header />
      <PageTitle title="Shop Products" breadcrumbs={[{ label: 'Shop' }]} />

      <section className="shop-section pt-80 pb-80">
        <div className="auto-container">
          {cartCount > 0 && (
            <div className="cart-notice wow fadeInDown">
              <i className="fas fa-cart-shopping"></i>
              <span>You have <strong>{cartCount}</strong> item{cartCount !== 1 ? 's' : ''} in your cart.</span>
              <a href="/cart" className="cart-notice-link">View Cart &rarr;</a>
            </div>
          )}
          <div className="row g-4">
            {products.map((p, i) => (
              <div key={p.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-6 wow fadeInUp" data-wow-delay={`${(i % 4) * 100}ms`}>
                <ProductCard product={p} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
